import { SM, TreeItem, TreeItemBase } from "../base";

export function flattenTreeArray<T>(arr: T[], childrenProp: keyof T, removeChildren = true): T[] {
    const res: T[] = [];
    for (const node of arr) {
        res.push(node);
        if (node[childrenProp] && Array.isArray(node[childrenProp])) {
            res.push(...flattenTreeArray(node[childrenProp], childrenProp));
            if (removeChildren) {
                delete node[childrenProp];
            }
        }
    }
    return res;
}

export function traverseTreeArray<T>(arr: T[], childrenProp: keyof T, cb: (node: T) => (void | boolean)): void | boolean {
    for (const node of arr) {
        if (cb(node)) {
            return true;
        }
        if (node[childrenProp] && Array.isArray(node[childrenProp])) {
            if (traverseTreeArray<T>(node[childrenProp] as any, childrenProp, cb)) {
                return true;
            }
        }
    }
}

export function replaceTreeArray<T>(arr: T[], childrenProp: keyof T, cb: (node: T) => (void | T)): T[] {
    for (let i = 0; i < arr.length; i ++) {
        const node = arr[i];
        if (node[childrenProp] && Array.isArray(node[childrenProp])) {
            replaceTreeArray<T>(node[childrenProp], childrenProp, cb);
        }
        const nn = cb(node);
        if (nn) {
            arr[i] = nn;
        }
    }
    return arr;
}

export function filterTreeArray<T>(arr: T[], childrenProp: keyof T, filter: (node: T) => (void | boolean)): T[] {
    const res = arr.map(v => Object.assign({}, v));
    for (const node of res) {
        if (node[childrenProp] && Array.isArray(node[childrenProp])) {
            node[childrenProp] = (filterTreeArray<T>(node[childrenProp] as any, childrenProp, filter) as T[]).filter(filter) as any;
        }
    }
    return res.filter(filter);
}

export function findInTreeArray<T>(arr: T[], childrenProp: keyof T, cb: (node: T) => (void | boolean)): void | T {
    for (const node of arr) {
        if (cb(node)) {
            return node;
        }
        if (node[childrenProp] && Array.isArray(node[childrenProp])) {
            const chn = findInTreeArray<T>(node[childrenProp] as any, childrenProp, cb);
            if (chn) {
                return chn;
            }
        }
    }
}

export function makeObjectsTree<T extends TreeItemBase>(items: TreeItem<T>[], sortFn: (a: any, b: any) => number): TreeItem<T>[] {
    items.forEach(x => delete x.children);
    const im: SM<TreeItem<T>> = items.reduce((obj, t) => ({ ...obj, [t.id!]: t }), {});
    const ch: SM<boolean> = {};
    for (const item of Object.values(im)) {
        if (item.parentId && im[item.parentId]) {
            if (im[item.parentId].children != undefined) {
                im[item.parentId].children?.push(item);
                im[item.parentId].children?.sort(sortFn);
            }
            else {
                im[item.parentId].children = [item];
            }
            // im[item.parentId]._expanded = true;
            ch[item.id!]= true;
        }
    }
    return Object.keys(im).filter(id => !ch[id!]).map(id => im[id!]).sort(sortFn);
}

export function getChildrenFromTree<T extends TreeItemBase>(tree: TreeItem<T>[], parentId: string): TreeItem<T>[] {
    const parent = findInTreeArray(tree, 'children', x => x.id == parentId);
    if (!parent || !parent.children?.length) {
        return [];
    }
    const res: TreeItem<T>[] = [];
    const children = parent.children;
    while (children.length) {
        const item = children.pop();
        if (item) {
            res.push(item);
            if (item.children?.length) {
                children.push(...item.children);
                delete item.children;
            }
        }
    }
    return res;
}

export function updateTreeBranch<T extends TreeItemBase>(tree: TreeItem<T>[], parentId: string, fn: (x: TreeItem<T>) => void | boolean): void {
    const parent = findInTreeArray(tree, 'children', x => x.id == parentId);
    if (parent) {
        updateTreeItem(parent, fn);
    }
}

export function updateTreeItem<T extends TreeItemBase>(parent: TreeItem<T>, fn: (x: TreeItem<T>) => void | boolean): void {
    fn(parent);
    parent.children?.forEach(x => updateTreeItem(x, fn));
}
